import React from 'react';
import { useSitecoreContext, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';

type LayoutComponentProps = {
  rendering: ComponentRendering;
};

function withValidDatasourceEnhancer<ComponentProps extends LayoutComponentProps>(
  Component: React.ComponentType<ComponentProps>
) {
  return function WithValidDatasource(props: ComponentProps) {
    const { sitecoreContext } = useSitecoreContext();
    const { pageState } = sitecoreContext;
    const isNormalPageMode = pageState === 'normal';

    // Renderings have fields - valid case, render the component
    if (props?.rendering?.fields) {
      return <Component {...props} />;
    }

    // Datasource is missing or invalid but normal page view - hide the component
    if (isNormalPageMode) {
      return <></>;
    }

    // Datasource is missing or invalid but preview or EE mode - show warning
    return (
      <div className="sc-jss-editing-error" role="alert">
        Datasource is required. Please choose the correct content item for this component.
      </div>
    );
  };
}

export const withValidDatasourceCheck = () => withValidDatasourceEnhancer;
export default withValidDatasourceCheck;
